import Image from 'next/image';

import {Typography} from '@kasta-io/components';

import {useLocation} from '@/contexts/LocationContext';
import useIsTargetMedia from '@/hooks/useIsTargetMedia';

import type {BannerItem} from './data';

import {data} from './data';
import s from './OnboardingBanner.module.scss';

export interface OnboardingBannerProps {}

const MAX_HEIGHT = 800;

const OnboardingBanner = ({...props}: OnboardingBannerProps) => {
  const {countryImageCode} = useLocation();
  const isMobileDevice = useIsTargetMedia('onboarding-banner', 'less');
  const language = data[countryImageCode.toLowerCase() as keyof typeof data];

  return (
    <div className={s.container} {...props}>
      <div className={s.content}>
        <Typography
          as="h3"
          variant={
            isMobileDevice || ((typeof window !== 'undefined' && window?.innerHeight) || 0) <= MAX_HEIGHT
              ? 'h4'
              : 'h3'
          }
          color="var(--colors-neutral-900)">
          {language.title}
        </Typography>

        <ul className={s.list}>
          {language.items.map(({text, image}: BannerItem) => (
            <li className={s.item} key={text}>
              <div className={s.banner}>
                <Image src={`/images/onboarding-banner/${image}.svg`} alt={text} width={120} height={120} />
                <Typography variant="subtitle3" weight="bold" color="var(--colors-neutral-600)">
                  {text}
                </Typography>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export {OnboardingBanner};
